(function() {
  const sectionSelector = '.js-loadmore';
  const gridSelector = '.js-grid-items';
  const inputSelector = '#search-articles';
  const countSelector = '.js-main-blog-count';
  const serverPaginationSelector = '.pagination, .pagination-load-more, [data-pagination]';
  const loadMoreSelectors = ['.js-load-more-btn','.js-load-more-pagination','.pagination','.pagination-load-more','[data-pagination]'];
  const maxResults = 250;

  const debounce = (fn, ms=250) => { let t; return (...a)=>{ clearTimeout(t); t=setTimeout(()=>fn(...a), ms); }; };
  const escapeHTML = (s='') => s.replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;', "'":'&#39;'}[c]));
  const buildSrcset = (url, widths=[165,360,533,720,1000,1280]) => {
    const delim = url.includes('?') ? '&' : '?';
    return widths.map(w => `${url}${delim}width=${w} ${w}w`).join(',');
  };
  const getImageMeta = (a) => {
    const imageUrl = (a?.image?.src || a?.image || a?.featured_image?.url || a?.featured_image) || '';
    const aspect = Number(a?.image?.aspect_ratio) || Number(a?.featured_image?.aspect_ratio) || 0.667;
    const ratioPercent = (1 / aspect) * 100;
    return { imageUrl, ratioPercent };
  };
  const formatDate = (iso) => {
    try { const d=new Date(iso); if (isNaN(d)) return {text:'',iso:''};
      return { text:d.toLocaleDateString('en-US',{year:'numeric',month:'long',day:'numeric'}), iso:d.toISOString() };
    } catch(_) { return {text:'',iso:''}; }
  };

  const buildArticleCardHTML = (a) => {
    const url = a.url || a.permalink || '#';
    const title = a.title ? escapeHTML(a.title) : 'Untitled';
    const excerptHtml = a.excerpt || a.body || a.content || '';
    const plainExcerpt = (excerptHtml || '').replace(/<[^>]+>/g, '');
    const shortExcerpt = escapeHTML(plainExcerpt.slice(0, 90));
    const { imageUrl, ratioPercent } = getImageMeta(a);
    const { text: dateText, iso: dateIso } = formatDate(a.published_at || a.publishedAt || a.date || a.created_at);

    const imgBlock = imageUrl ? `
      <div class="article-card__image media">
        <a href="${url}">
          <img
            srcset="${buildSrcset(imageUrl)}"
            src="${imageUrl}${imageUrl.includes('?') ? '&' : '?'}width=533"
            sizes="(min-width: 1400px) 650px, (min-width: 750px) calc((100vw - 130px) / 2), calc((100vw - 50px) / 2)"
            alt="${title}"
            class="motion-reduce"
            loading="lazy"
            width="1280"
            height="1919">
        </a>
      </div>` : '';

    return `
<div class="blog-articles__article article">
  <div class="article-card-wrapper card-wrapper">
    <div class="card article-card card--standard article-card__image--large card--media" style="--ratio-percent: ${ratioPercent}%;">
      <div class="card__inner  color-scheme-2 gradient ratio" style="--ratio-percent: ${ratioPercent}%;">
        <div class="article-card__image-wrapper card__media">${imgBlock}</div>
        <div class="card__content">
          <div class="card__information">
            <h3 class="card__heading h2"><a href="${url}" class="full-unstyled-link">${title}</a></h3>
            <div class="article-card__info caption-with-letter-spacing h5"><span class="circle-divider">${dateIso ? `<time datetime="${dateIso}">${dateText}</time>` : ``}</span></div>
            ${shortExcerpt ? `<p class="article-card__excerpt rte-width">${shortExcerpt}${plainExcerpt.length > 90 ? '…' : ''}</p>` : ''}
            <div class="article-card__footer"></div>
          </div>
        </div>
      </div>
      <div class="article-card__content">
        <div class="article-card__content-inner">
          <h5 class="article-card__title"><a href="${url}">${title}</a></h5>
          ${shortExcerpt ? `<div class="article-card__excerpt">${shortExcerpt}${plainExcerpt.length > 90 ? '...' : ''}</div>` : ''}
          <a class="article-card__link" href="${url}">Read more</a>
        </div>
        <div class="article-card__date">${dateIso ? `<time datetime="${dateIso}">${dateText}</time>` : ``}</div>
      </div>
    </div>
  </div>
</div>`;
  };

  const getSection = () => document.querySelector(sectionSelector);
  const getGrid = () => document.querySelector(gridSelector);
  const getCount = () => document.querySelector(countSelector);

  const getSectionId = () => {
    const sec = getSection();
    if (!sec) return null;
    const a = sec.getAttribute('data-section-id');
    if (a) return a;
    const parent = sec.closest('[data-section-id]');
    if (parent) return parent.getAttribute('data-section-id');
    const shopify = sec.closest('[id^="shopify-section-"]');
    if (shopify) return shopify.id.replace(/^shopify-section-/, '');
    return null;
  };

  const initLoadMore = (scope = document) => {
    if (typeof window.initLoadMoreOn === 'function') {
      scope.querySelectorAll(sectionSelector).forEach(root => {
        if (root.dataset.loadmoreInit === '1') return;
        window.initLoadMoreOn(root);
        root.dataset.loadmoreInit = '1';
      });
    } else if (typeof window.LoadMore === 'function') {
      scope.querySelectorAll(sectionSelector).forEach(root => {
        if (root.dataset.loadmoreInit === '1') return;
        try { new window.LoadMore(root); } catch(e) { console.warn(e); }
        root.dataset.loadmoreInit = '1';
      });
    }
  };

  const fetchAndRestoreServerSection = async () => {
    const secId = getSectionId();
    if (!secId) throw new Error('No data-section-id on section wrapper');

    const url = new URL(window.location.href);
    url.searchParams.delete('q');
    url.searchParams.delete('type');
    url.searchParams.set('section_id', secId);

    const res = await fetch(url.toString(), { headers: { 'X-Requested-With': 'XMLHttpRequest' }, credentials: 'same-origin' });
    if (!res.ok) throw new Error(`Section restore failed: ${res.status}`);

    const html = await res.text();
    const tmp = document.createElement('div');
    tmp.innerHTML = html;

    let newSection =
      tmp.querySelector(`[data-section-id="${secId}"]`) ||
      tmp.querySelector(`#shopify-section-${secId}`) ||
      tmp.querySelector(sectionSelector) ||
      tmp.firstElementChild;

    const current = getSection();
    if (current && newSection) {
      current.replaceWith(newSection);
      requestAnimationFrame(() => {
        initLoadMore(newSection);
        if (typeof window.initializeObservers === 'function') {
          try { window.initializeObservers(); } catch(_) {}
        }
      });
    }
  };

  let originalHTML = null;
  const ensureOriginalHTML = () => {
    if (!originalHTML) {
      const sec = getSection();
      if (sec) originalHTML = sec.outerHTML;
    }
  };
  const restoreFromSnapshot = () => {
    if (!originalHTML) return;
    const tmp = document.createElement('div');
    tmp.innerHTML = originalHTML;
    const restored = tmp.firstElementChild;
    const current = getSection();
    if (current && restored) {
      current.replaceWith(restored);
      requestAnimationFrame(() => {
        initLoadMore(restored);
        if (typeof window.initializeObservers === 'function') {
          try { window.initializeObservers(); } catch(_) {}
        }
      });
    }
  };

  const restoreOriginal = async () => {
    try { await fetchAndRestoreServerSection(); }
    catch (e) { console.warn('Server restore failed, using snapshot:', e); restoreFromSnapshot(); }
  };

  const hideServerPagination = () => {
    const sec = getSection();
    if (!sec) return;
    const p = sec.querySelector(serverPaginationSelector);
    if (p) p.style.display = 'none';
  };
  const hideLoadMoreInSection = () => {
    const sec = getSection();
    if (!sec) return;
    loadMoreSelectors.forEach(sel => {
      sec.querySelectorAll(sel).forEach(el => {
        el.style.display = 'none';
        el.setAttribute('aria-hidden', 'true');
      });
    });
  };
  const setCount = (n) => {
    const el = getCount();
    if (el) el.textContent = `Showing ${n} Articles`;
  };

  const fetchArticles = async (query) => {
    const url = `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=article&resources[limit]=${maxResults}`;
    const res = await fetch(url, { headers: { 'Accept':'application/json' }, credentials: 'same-origin' });
    if (!res.ok) throw new Error(`Search failed: ${res.status}`);
    const data = await res.json();
    const list = data?.resources?.results?.articles || [];
    return list.sort((a,b)=> new Date(b.published_at || 0) - new Date(a.published_at || 0));
  };

  let searchToken = 0;
  const runSearch = async () => {
    const input = document.querySelector(inputSelector);
    const q = (input ? input.value : '').trim();
    const token = ++searchToken;

    if (!q) {
      requestAnimationFrame(restoreOriginal);
      return;
    }

    try {
      const results = await fetchArticles(q);
      if (token !== searchToken) return;

      const html = results.map(buildArticleCardHTML).join('');
      requestAnimationFrame(() => {
        if (token !== searchToken) return;
        hideServerPagination();
        hideLoadMoreInSection();
        const grid = getGrid();
        if (grid) grid.innerHTML = html || `
          <div class="empty-state">
            <h3 class="card__heading h5">No results</h3>   
          </div>`;
        setCount(results.length);
      });
    } catch (e) {
      console.error(e);
    }
  };

  const debouncedRunSearch = debounce(runSearch, 250);
  document.addEventListener('input', (e) => {
    if (!e.target || !e.target.matches(inputSelector)) return;
    ensureOriginalHTML();
    debouncedRunSearch();
  });

  document.addEventListener('click', (e) => {
    const root = e.target.closest(sectionSelector);
    const btn  = e.target.closest('.js-load-more-btn');
    if (!root || !btn) return;
    if (root.dataset.loadmoreInit === '1') return; 

    initLoadMore(root);
    const evt = new MouseEvent('click', { bubbles: true, cancelable: true, view: window });
    btn.dispatchEvent(evt);
  });
})();

document.addEventListener('click', (e) => {
  const btn = e.target.closest('.js-load-more-btn');
  if (!btn) return;

  const root = btn.closest('.js-loadmore');
  if (!root) return;

  if (root.dataset.loadmoreInit === '1') return;

  e.preventDefault();
  e.stopPropagation();

  if (typeof window.initLoadMoreOn === 'function') {
    window.initLoadMoreOn(root);
  } else if (typeof window.LoadMore === 'function') {
    try { new window.LoadMore(root); } catch (err) { console.warn(err); }
  }

  root.dataset.loadmoreInit = '1';

  setTimeout(() => {
    const evt = new MouseEvent('click', { bubbles: true, cancelable: true, view: window });
    btn.dispatchEvent(evt);
  }, 0);
}, true); 